import React from "react";
import "./LegalPages.css";

function CancellationPolicyPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Cancellation Policy</h1>
        <p className="legal-subtitle">Last updated: March 21, 2026</p>

        <section className="legal-section">
          <h2>Subscription Cancellation</h2>
          <p>
            You may choose to cancel auto-renewal of your subscription at any time from your
            account settings or by contacting support.
          </p>
        </section>

        <section className="legal-section">
          <h2>Effect of Cancellation</h2>
          <p>
            On cancellation, your plan will remain active until the end of the current billing
            cycle. No additional renewal charge will be made after that cycle.
          </p>
        </section>

        <section className="legal-section">
          <h2>Refund Note</h2>
          <p>
            Cancellation of subscription does not automatically create eligibility for refund.
            Please refer to the Refund Policy for complete refund terms.
          </p>
        </section>

        <div className="legal-footer-note">
          Support Email: ishan@erishsolutions.com
        </div>
      </div>
    </div>
  );
}

export default CancellationPolicyPage;
